module.exports = __webpack_public_path__ + "img/flowers5.5ec8b757.jpg";